import { render, staticRenderFns } from "./VariacaoProdutoModal.vue?vue&type=template&id=dd32243c"
import script from "./VariacaoProdutoModal.vue?vue&type=script&lang=js"
export * from "./VariacaoProdutoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports